import { render, staticRenderFns } from "./vSelectZona.vue?vue&type=template&id=fe59e160&scoped=true&"
import script from "./vSelectZona.vue?vue&type=script&lang=js&"
export * from "./vSelectZona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe59e160",
  null
  
)

export default component.exports